export default function Home() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <p className="text-gray-500 text-lg">Box Warehouse - Sua solução de armazenagem</p>
    </div>
  );
}
